import React, { useState, useEffect } from 'react';
import { getInitialImageForTaskId } from './utils';

const ImageDisplayTarget = ({
    taskId
}) => {
    const [fadeIn, setFadeIn] = useState(false);

    // Effekt für sanften Übergang beim Bildwechsel
    useEffect(() => {
        setFadeIn(false);
        const timer = setTimeout(() => {
            setFadeIn(true);
        }, 50); // Kurze Verzögerung für den Fade-Effekt
        return () => clearTimeout(timer);
    }, [taskId]);

    return (
        <div className='targetImageContainer'>
            <h2>Target Dress</h2>
            {taskId ? (
                <img
                    className='targetImage'
                    src={getInitialImageForTaskId(taskId)[0]}
                    alt={`Target Image for Task ${taskId}`}
                    style={{
                        transition: 'opacity 0.5s ease-in-out',
                        opacity: fadeIn ? 1 : 0.5 
                    }}
                    onError={(e) => {
                        console.error("Fehler beim Laden des Bildes:", e);
                        e.target.src = getInitialImageForTaskId(taskId)[0] + "?reload=" + new Date().getTime();
                    }}
                />
            ) : (
                <div className='targetImage' style={{
                        transition: 'opacity 0.5s ease-in-out',
                        opacity: fadeIn ? 1 : 0.5 
                    }}>
                    Loading new task images...
                </div>
            )}
        </div>
    );
};

export default ImageDisplayTarget;